module.exports = __webpack_public_path__ + "static/img/qq.a90a4884.png";